import React from 'react';
import { View, Text, Pressable, FlatList } from 'react-native';

import {
  OPComponent,
  OPPureComponent,
  Container,
  I18n,
  SimpleHeader,
  CheckButtonList,
  CheckView,
} from '../components';

import ResidentSelect from '../airforce/resident_select';
import SelectedAirman from '../airforce/selected_airman';

import { connect } from 'react-redux';

import { getGroupsForEmployer, getCurrentEmployer } from '../../selectors/employers';

import { notificationsSettings } from '../userProfile/selector';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

class ResBtn extends OPPureComponent {
  handlePress = () => {
    this.props.onPress && this.props.onPress(this.props.case);
  };

  render() {
    const props = this.props;

    return (
      <Pressable
        key={props.case.caseId}
        onPress={this.handlePress}
        style={[THEME.basicRow, { paddingRight: 25 }]}
      >
        <SelectedAirman
          containerStyle={{ flex: 1 }}
          case={props.case}
          patient={props.patient}
          onPress={this.handlePress}
        />
        <CheckView checked={true} />
      </Pressable>
    );
  }
}

class NotificationsSettings extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedGroups: this.prepGroupItems(props),
      selectedCases: this.prepCasesItems(props),
    };
  }

  componentDidMount() {
    this.props.onValueChange({
      employers: {
        [this.props.currentEmployer.employerId]: {
          groups: this.state.selectedGroups
            .map((g) => (g.checked ? g.id : null))
            .filter((g) => !!g),
          cases: this.state.selectedCases.map((c) => c.caseId),
        },
      },
    });
  }

  componentDidUpdate(prevProp, prevState) {
    if (
      prevState.selectedGroups !== this.state.selectedGroups ||
      prevState.selectedCases !== this.state.selectedCases
    ) {
      this.props.onValueChange({
        employers: {
          [this.props.currentEmployer.employerId]: {
            groups: this.state.selectedGroups
              .map((g) => (g.checked ? g.id : null))
              .filter((g) => !!g),
            cases: this.state.selectedCases.map((c) => c.caseId),
          },
        },
      });
    }
  }

  prepCasesItems = (props) => {
    const settingsCases = props.settings?.cases ?? [];
    return settingsCases.map((caseId) => this.props.casesById[caseId]);
  };

  prepGroupItems = (props) => {
    const settingsGroups = props.settings?.groups ?? [];
    return props.groupsForEmployer.map((g) => {
      return {
        id: g,
        label: g,
        checked: settingsGroups.includes(g),
      };
    });
  };

  handleGroupSelection = (selectedGroups) => {
    this.setState({ selectedGroups });
  };

  oneResidentHeaderText = (txt) => {
    if (txt === 'A AIRMAN') return 'AN AIRMAN';

    return txt;
  };

  handleResidentSelectValueChange = () => {
    this.setState({
      errorMessage: null,
    });
  };
  handleSelectResident = (caseId) => {
    const selectedCase = this.props.casesById[caseId];

    this.setState({
      selectedCases: this.state.selectedCases.concat(selectedCase),
    });
  };

  handleResidentTap = (tappedC) => {
    this.setState({
      selectedCases: this.state.selectedCases.filter((c) => c !== tappedC),
    });
  };

  renderSelectedCase = ({ item }) => {
    if (!item) return null;
    const c = item;

    const patient = this.props.patientsById[c.patientId];

    return <ResBtn case={c} patient={patient} onPress={this.handleResidentTap} />;
  };

  render() {
    return (
      <Container>
        <View style={THEME.header}>
          <Text style={THEME.headerText}>{I18n.t('settingsScreen.turnNotificationsOnFor')}</Text>
        </View>

        <View style={{ flex: 0.4 }}>
          <SimpleHeader label={I18n.ac_aec('employer.allResidentsOfAGroup')} />
          <CheckButtonList
            items={this.state.selectedGroups}
            multi={true}
            scrollable={true}
            onValuesChanged={this.handleGroupSelection}
          />
        </View>

        <SimpleHeader label={this.oneResidentHeaderText(I18n.ac_aec('employer.oneResident'))} />
        <View style={{ flex: 0.6, paddingTop: 60 }}>
          <FlatList
            style={{ flex: 1 }}
            data={this.state.selectedCases}
            renderItem={this.renderSelectedCase}
            keyExtractor={(item) => `${item.caseId}`}
          />
          <ResidentSelect
            onValueChange={this.handleResidentSelectValueChange}
            onSelectCase={this.handleSelectResident}
          />
        </View>
      </Container>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    groupsForEmployer: getGroupsForEmployer(state),
    currentEmployer: getCurrentEmployer(state),
    casesById: state.entities.cases,
    patientsById: state.entities.patients,
    settings: notificationsSettings(state),
  };
}

export default connect(mapStateToProps, null)(NotificationsSettings);
